import {
  ImageCustomMetadata,
  CustomMetadataValue,
  CustomMetadataFieldType,
} from "types";
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const getFormattedCustomMetadataValue = (
  field: ImageCustomMetadata,
): string => {
  const { field_type, value } = field;

  const formatters: Record<
    CustomMetadataFieldType,
    (value: CustomMetadataValue) => string
  > = {
    string: (value) => String(value),
    float: (value) => String(value),
    enum: (value) => (Array.isArray(value) ? value.join(", ") : String(value)),
    link: (value) => (Array.isArray(value) ? value.join(", ") : String(value)),
    datetime: (value) => new Date(value as string | number).toLocaleString(),
    geolocation: (value) =>
      Array.isArray(value) && value.length >= 2
        ? `Lat: ${value[0]}, Lon: ${value[1]}`
        : String(value),
  };

  const formatter = formatters[field_type];
  return formatter ? formatter(value) : String(value);
};

// Utility functions for converting between dayjs objects and formatted strings
export const formatDateForAPI = (date: Dayjs | null): string | null =>
  date?.utc().format("YYYY-MM-DDTHH:mm:ss[Z]") || null;

export const formatDateRangeForAPI = (
  dateRange: [Dayjs, Dayjs] | null,
): [string, string] | null =>
  dateRange
    ? [formatDateForAPI(dateRange[0])!, formatDateForAPI(dateRange[1])!]
    : null;

export const parseDateFromAPI = (dateString: string | null): Dayjs | null =>
  dateString ? dayjs(dateString).local() : null;

export const parseDateRangeFromAPI = (
  dateRange: [string, string] | null,
): [Dayjs, Dayjs] | null =>
  dateRange
    ? [parseDateFromAPI(dateRange[0])!, parseDateFromAPI(dateRange[1])!]
    : null;
